// extracted by mini-css-extract-plugin
export default {"infoContainer":"BLvaAh0S4ggq6wmvngFl","teacher":"IiPBVag3alNV_Yhs3xb7","loginBtnContainer":"ekwdVvn5TAumVkNhWRHZ"};